import SystemEnum from '@/assets/js/systemEnum'
import DataType from '@/util/dataType'
const WORK_QUEUE = SystemEnum.WORK_QUEUE_ENUM
const IN_HOUSE_SPECIAL_QUEUE = [
  {
    status: WORK_QUEUE.IN_HOUSE_COLLECTION.value,
    title: WORK_QUEUE.IN_HOUSE_COLLECTION.text,
    key: WORK_QUEUE.IN_HOUSE_COLLECTION.key,
    features: WORK_QUEUE.IN_HOUSE_COLLECTION.features,
    code: DataType.PrivilegeCode.IN_HOUSE_COLLECTION,
    color: ['#685DE8', '#F3F2FD'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.IN_HOUSE_REPLAN.value,
    title: WORK_QUEUE.IN_HOUSE_REPLAN.text,
    key: WORK_QUEUE.IN_HOUSE_REPLAN.key,
    features: WORK_QUEUE.IN_HOUSE_REPLAN.features,
    code: DataType.PrivilegeCode.IN_HOUSE_REPLAN,
    color: ['#B05CE3', '#F7F2FD'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.IN_HOUSE_REJECTED.value,
    title: WORK_QUEUE.BROKEN_PROMISE.text,
    key: WORK_QUEUE.BROKEN_PROMISE.key,
    features: WORK_QUEUE.IN_HOUSE_REJECTED.features,
    code: DataType.PrivilegeCode.IN_HOUSE_REJECTED,
    color: ['#F67E9B', '#FFF4F7'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true,
    beginSize: 0,
    rejectedPage: 1,
    searchRejected: 1
  },
  {
    status: WORK_QUEUE.IN_HOUSE_REPLAN_PAID_OFF.value,
    title: WORK_QUEUE.IN_HOUSE_REPLAN_PAID_OFF.text,
    key: WORK_QUEUE.IN_HOUSE_REPLAN_PAID_OFF.key,
    features: WORK_QUEUE.IN_HOUSE_REPLAN_PAID_OFF.features,
    code: DataType.PrivilegeCode.IN_HOUSE_REPLAN_PAID_OFF,
    color: ['#FFC700', '#FFFCF2'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
export default IN_HOUSE_SPECIAL_QUEUE
